export default __webpack_public_path__ + "static/media/icon-star.fcc98511.svg";